import { render } from "./NewPaymentMod.vue?vue&type=template&id=aeb8e8ac&ts=true"
import script from "./NewPaymentMod.vue?vue&type=script&lang=ts"
export * from "./NewPaymentMod.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__